/* tslint:disable */
var TRegularMultiOptions = {...TBaseMultiOptions,

    buildCombo (mode, selections)
    {
        this.isRenderedIcon = false;

        return `
			<div id="combo_options" class="betsOptions combo expanded" data-uat="combo-options">
                ${this.buildComboOptionsTitle(mode)}
                <input id="comboOptions" type="radio" name="betOptions" value="combo" onchange="UniSlipBlock.selectSlipMode(this.value)" style="display: none;" checked="checked" />
                <div class="betsOptionsWrap">
                    ${this.buildComboInner(mode, selections)}
                    ${this.buildQuickStakeButtons(mode)}
                </div>
                ${this.buildComboBonusMessage(this.isRenderedIcon)}
            </div>
        `;
    },

    buildUKMultiplesOptions (mode, selections)
    {
        BetSlipUtil.getAllBetsDepositValue(mode);
        var deposit = Bets.formatStake(mode.AllBetsDeposit);
        var showMultiplesClass = mode.ShowMultiples ? "" : "collapsed";
        var toReturnValue = mode.AllBetsDeposit > 0 ? mode.getSinglesAllReturn() : "";
        this.isRenderedIcon = false;
        return `
            <div class="betsOptions uk_multiples" id="jsBetslipMultiples">
                <div class="ukSlipHeading ukSlipHeading--toggleable ${showMultiplesClass}" id="jsUkToggleableHeader" onclick="UniSlipBlock.toggleMultiples('collapsed')">
                    ${$dict.bs("Multiples")}
                    <span class="icon arrow_down" rel="arr_icon"></span>
                </div>
                <div class="ukSlipOptions">
                    <div class="betSlip_row_wrapper ukSlipOptions__line">
                        <div class="betSlip_row_content">
                            <div>
                                <strong>${$dict.bs("Singles")}</strong> -
                                ${BetSlip.getSelectionsCount()} ${$dict.bs("Bets")}
                            </div>
                        </div>
                        <div class="betslipStakeLine clearfix">
                            <div class="betslipStakeLine__return returnBox">
                                <span class="returnBox__head">
                                    ${$string("BettingHistory").Return}
                                </span>
                                <span class="returnBox__value" id="singlesAll_return_value">
                                    ${toReturnValue}
                                </span>
                            </div>
                            <div class="betslipStakeLine__stake">
                                <div class="betslipStakeLine__stakeInner clearfix">
                                    ${TSlipShared.createStakeBox(this.getAllStakeBoxInner(deposit), deposit)}
                                </div>
                            </div>
                        </div>
                    </div>
                    ${this.buildComboInner(mode, selections)}
                    ${this.buildUKSystemInner(mode, selections)}
                </div>
                ${this.buildComboBonusMessage(this.isRenderedIcon)}
            </div>
        `;
    },

    buildSystem (mode, selections)
    {
        return `
			<div id="system-options" class="betsOptions system" data-uat="system-options">
                <div class="heading openable">
                    <label for="systemOptions">
                        ${$dict.bs("SystemOptionsTitle")}
                    </label>
                </div>
                <input id="systemOptions" type="radio" name="betOptions" value="system" onchange="UniSlipBlock.selectSlipMode(this.value)" style="display: none;" />
                <div class="betsOptionsWrap">
                    ${this.buildSystemInner(mode, selections)}
                </div>
                <div id="comboAdditionalMsgWrapper">
		            ${this.buildComboBonusMessageInSystem(mode)}
                </div>
            </div>
        `;
    },

    buildSystemInnerLayout (mode, options)
    {
        return `
            <div class="betSlip_row_wrapper">
                <div class="betSlip_row_content">
                    ${this.buildSystemOptionGroups(mode, options)}
                </div>
                <div class="betSlip_row_stake system">
                    ${this.buildSystemStakeAndEWBoxes(mode, options)}
                    <div id="comboBonusIconWrapper">
                        ${this.buildComboBonusIconInSystem(mode, options)}
                    </div>
                </div>
            </div>
        `;
    },

    buildSystemOptionGroups(mode, options)
    {
        var __html = "";
        __html += `
            <div class="betsOptionsGroup" id="betsOptionsDiv" data-uat="bets-options-div">`;
                //Individual variants
                if (options.linesCount <= mode.MaxSelections) {
                   __html += this.buildSystemIndividualVariants(mode, options);
                } __html += `
                ${this.buildSystemNamedVariants(mode, options)}
            </div>
        `;
        return __html;
    },

    createSystemVariantLine (mode, options)
    {
        return `
            <label>
                <input class="betsOption" name="systemType" value="${options.key}" type="radio" onclick="rebuildSystemStake()" ${mode.SystemKey == options.key ? "checked='1'" : ""}${mode.IsBetInProcess && mode.SystemKey != options.key ? " disabled" : ""}/>
                <span class="betsOptionsName">
                    ${options.systemName} (${options.betsCount} ${$dict.bs("ComboNamesBets")})
                </span>
            </label>
        `;
    },

    createComboVariantLine (mode, options, selections, betType, isFirst)
    {
        var isFullVariant = options.hasOwnProperty("odds");
        var hasComboBonusClass = (ComboBonusProvider.ComboBonuses != null && !Modes.isCombinatorMode(mode)) ? "has_combo_bonus" : "";
        var freeBet = Modes.getAvailableMultiFreeBets(mode, selections, options.key);

        var hasFreeBetClass = freeBet ? "has_free_bet" : "";

        var __html = `
            <div id="betSlip_row_wrapper_${options.key}" class="betSlip_row_wrapper${IsUKBetSlip ? " ukSlipOptions__line" : ""} ${addCustomClass("with-combo-max-bet", mode.IsMaxBetButtonEnabled())}">
            ${TSlipShared.createComboMaxBet(mode, isFirst)}
            <div class="betSlip_row_content ${hasComboBonusClass} ${hasFreeBetClass}">
                <div>
                    <strong>${Modes.isCombinatorMode(mode) ? mode.ComboNames[options.key] : $dict.bs("ComboNames_" + options.key)}</strong>
                    <br/>`;
                    if (isFullVariant) { __html += `
                        ${options.comboName}: <span id="comboSingleOdds">${options.odds}</span>`;
                    } else { __html += `
                        ${options.betsCount} ${options.comboName}`;
                    } __html += `
                    ${this.buildComboBonusIcon(betType, freeBet, mode)}`;
                    if (options.hasEachway) { __html += `
                        ${this.createEachwayBox.defaultBox(mode, options)}`;
                    } __html += `
                    ${TMinMax.createMinForComboSlipMode(mode, selections)}
                </div>
            </div>
            <div class="betSlip_row_stake combo">
                ${TSlipShared.createStakeBox(this.getComboVariantStakeBoxInner(options), options.deposit)}
                ${this.createMultiFreeBetSelect(mode, selections, options.key)}
            </div>
        </div>`;
        return __html;
    },

    createUKComboVariantLine (mode, options, selections, betType)
    {
        var isFullVariant = options.hasOwnProperty("odds");
        var toReturnValue = mode.getComboVariantReturn(options.key) || "";
        var freeBet = Modes.getAvailableFreeBetsForUKSlip(mode, UKSlipModeSubModes.Combo, null, selections, options.key);

        var __html = `
            <div id="betSlip_row_wrapper_${options.key}" class="betSlip_row_wrapper${IsUKBetSlip ? " ukSlipOptions__line" : ""}">
                <div class="betSlip_row_content">
                    <div>
                        <strong>${$dict.bs("ComboNames_" + options.key)}</strong>`;
                        if (isFullVariant) { __html += `
                            @ <span id="comboSingleOdds" class="emphasis">${options.odds}</span>`;
                        } else { __html += `
                            ${options.betsCount} ${options.comboName}`;
                        } __html += `
                    </div>
                </div>
                <div class="betslipStakeLine clearfix">
                    <div class="betslipStakeLine__return returnBox">
                        <span class="returnBox__head">
                            ${$string("BettingHistory").Return}
                        </span>
                        <span class="returnBox__value" id="combo_return_value_${options.key}">
                            ${toReturnValue}
                        </span>
                    </div>
                    <div class="betslipStakeLine__stake">
                        <div class="betslipStakeLine__stakeInner clearfix">`;
                            if (options.hasEachway) {
                                __html += this.createEachwayBox.UKBox(mode, options)
                            } __html += `
                            ${TSlipShared.createStakeBox(this.getComboVariantStakeBoxInner(options), options.deposit)}
                            ${TSlipShared.createUKComboMaxBet(options, mode, selections)}
                            ${this.buildComboBonusIcon(betType, freeBet, mode)}
                        </div>
                    </div>
                    ${this.createUKMultiFreeBetSelect(mode, selections, options.key)}
                </div>
            </div>`;
        return __html;
    },

    createUKSystemVariantLine (mode, options, selections)
    {
        var toReturnValue = mode.getSystemVariantReturn(options.key) || "";
        var __html = `
            <div class="betSlip_row_wrapper ukSlipOptions__line systemxxx">
                <div class="betSlip_row_content">
                    <div>
                        <strong>${options.systemName}</strong> - ${options.betsCount} ${options.betsString}
                    </div>
                </div>
                <div class="betslipStakeLine clearfix">
                    <div class="betslipStakeLine__return returnBox">
                        <span class="returnBox__head">
                            ${$string("BettingHistory").Return}
                        </span>
                        <span class="returnBox__value" id="system_return_value_${options.key}"">
                            ${toReturnValue}
                        </span>
                    </div>
                    <div class="betslipStakeLine__stake">
                        <div class="betslipStakeLine__stakeInner clearfix">`;
                            if (options.hasEachway) {
                                __html += this.createEachwayBox.UKBox(mode, options);
                            } __html += `
                            ${TSlipShared.createStakeBox(this.getSystemVariantStakeBoxInner(options), options.deposit)}
                            ${TSlipShared.createUKSystemMaxBet(options, mode, selections)}
                        </div>
                    </div>
                </div>
            </div>`;
        return __html;
    }};
window.TRegularMultiOptions = TRegularMultiOptions;
jsRequire("/templates/Mobile/UniSlip/MultiOptions/TRegularMultiOptions.ext.js");